import { useContext } from 'react';
import { PagePreviewContext } from '~/contexts/PagePreviewContext';

export function usePagePreview() {
    const contextData = useContext(PagePreviewContext);

    return contextData;
}
